export const GET_TEACHER_REQUEST = 'GET_TEACHER_REQUEST';
export const GET_TEACHER_SUCCESS = 'GET_TEACHER_SUCCESS';
export const GET_TEACHER_FAILURE = 'GET_TEACHER_FAILURE';

export const getTeacherByUserId = (productId, userProfileId) =>
    ({ type: GET_TEACHER_REQUEST, productId, userProfileId, isLoadingEditTeacherDetail: true });

export const getTeacherSuccess = ({ data }) => ({ type: GET_TEACHER_SUCCESS, data, isLoadingEditTeacherDetail: false, downloadingClassroomIds: new Set() });

export const getTeacherFailure = () =>
    ({ type: GET_TEACHER_FAILURE, isLoadingEditTeacherDetail: false });

export const OPEN_UNASSIGN_TEACHERS_MODAL = 'OPEN_UNASSIGN_TEACHERS_MODAL';
export const CLOSE_UNASSIGN_TEACHERS_MODAL_CONFIRMATION = 'CLOSE_UNASSIGN_TEACHERS_MODAL_CONFIRMATION';

export const openUnAssignTeachersModal = () =>
    ({ type: OPEN_UNASSIGN_TEACHERS_MODAL, isUnassignedModalOpen: true });

export const closeUnAssignTeachersModalConfirmation = () =>
    ({ type: CLOSE_UNASSIGN_TEACHERS_MODAL_CONFIRMATION, refreshTeachersAfterUnAssign: false });

export const UNASSIGN_TEACHERS_USING_CLASSID_REQUEST = 'UNASSIGN_TEACHERS_USING_CLASSID_REQUEST';
export const UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS = 'UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS';
export const UNASSIGN_TEACHERS_USING_CLASSID_FAILURE = 'UNASSIGN_TEACHERS_USING_CLASSID_FAILURE';
export const CLOSE_UNASSIGN_MODAL_REQUEST = 'CLOSE_UNASSIGN_MODAL_REQUEST';

export const unassignTeachersUsingClassId = (userProfileId, classId) =>
    ({ type: UNASSIGN_TEACHERS_USING_CLASSID_REQUEST, userProfileId, isUnassignedModalOpen: true, classId, unassignDisableButton: true });

export const unassignTeachersByClassIdSuccess = () =>
    ({ type: UNASSIGN_TEACHERS_USING_CLASSID_SUCCESS, isUnassignedModalOpen: false, unassignDisableButton: false });

export const unassignTeachersByClassIdFailure = () =>
    ({ type: UNASSIGN_TEACHERS_USING_CLASSID_FAILURE, unassignDisableButton: false });

export const closeUnassignModalRequest = () =>
    ({ type: CLOSE_UNASSIGN_MODAL_REQUEST });


export const EDIT_TEACHER_REQUEST = 'EDIT_TEACHER_REQUEST';
export const EDIT_TEACHER_SUCCESS_REQUEST = 'EDIT_TEACHER_SUCCESS_REQUEST';
export const EDIT_TEACHER_FAILURE_REQUEST = 'EDIT_TEACHER_FAILURE_REQUEST';

export function editTeacher(teacher, updatingTeacher, context) {
    teacher.title = teacher.title.trim();
    teacher.firstName = teacher.firstName.trim();
    teacher.lastName = teacher.lastName.trim();
    if (teacher.emailAddress) {
        teacher.emailAddress = teacher.emailAddress.trim();
    }
    return {
        type: EDIT_TEACHER_REQUEST,
        teacher,
        updatingTeacher,
        context
    };
}

export function editTeacherSuccess(context) {
    context.router.history.push('/teachers');
    return {
        type: EDIT_TEACHER_SUCCESS_REQUEST,
        updatingTeacher: false
    };
}

export function editTeacherFailure(isServerError, editTeacherValidationMessage) {
    return {
        type: EDIT_TEACHER_FAILURE_REQUEST,
        editTeacherValidationMessage,
        showEditTeacherValidationModal: true,
        updatingTeacher: false,
        isServerError
    };
}

export const CLOSE_EDIT_TEACHER_VALIDATION_MODAL = 'CLOSE_EDIT_TEACHER_VALIDATION_MODAL';

export function closeEditTeacherValidationModal() {
    return {
        type: CLOSE_EDIT_TEACHER_VALIDATION_MODAL,
        showEditTeacherValidationModal: false
    };
}

export const REFRESH_TEACHER_LIST_ON_CANCEL_REQUEST = 'REFRESH_TEACHER_LIST_ON_CANCEL_REQUEST';

export function refreshTeacherListOnCancel() {
    return { type: REFRESH_TEACHER_LIST_ON_CANCEL_REQUEST };
}

export const PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST = 'PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST';
export const PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_SUCCESS = 'PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_SUCCESS';
export const PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_FAILURE = 'PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_FAILURE';

export function printClassroomStudentsSignInCard(classroomId, productId, downloadingClassroomIds, SignInCardPageSizeType) {
    return { type: PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_REQUEST, classroomId, productId, downloadingClassroomIds, SignInCardPageSizeType };
}

export const printClassroomStudentsSignInCardSuccess = (classroomId, downloadUrl, downloadingClassroomIds) => {
    window.location.href = downloadUrl;
    downloadingClassroomIds.delete(classroomId);
    return ({ type: PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_SUCCESS, classroomId, downloadUrl, downloadingClassroomIds });
};

export const printClassroomStudentsSignInCardFailure = (classroomId, downloadingClassroomIds) => {
    downloadingClassroomIds.delete(classroomId);
    return ({ type: PRINT_CLASSROOM_STUDENTS_SIGN_IN_CARD_FAILURE, classroomId, downloadingClassroomIds });
};

export const SEND_PASSWORD_LINK_REQUEST = 'SEND_PASSWORD_LINK_REQUEST';
export const SEND_PASSWORD_LINK_SUCCESS = 'SEND_PASSWORD_LINK_SUCCESS';
export const SEND_PASSWORD_LINK_FAILURE = 'SEND_PASSWORD_LINK_FAILURE';
export const RESET_PASSWORD_PARAMETERS = 'RESET_PASSWORD_PARAMETERS';

export function sendPasswordLinkRequest(productId, userProfileId) {
    return { type: SEND_PASSWORD_LINK_REQUEST, productId, userProfileId };
}

export function sendPasswordLinkSuccess(status) {
    return { type: SEND_PASSWORD_LINK_SUCCESS, status };
}

export function sendPasswordLinkFailure(errorMessage) {
    return { type: SEND_PASSWORD_LINK_FAILURE, errorMessage };
}

export function resetPasswordParams() {
    return { type: RESET_PASSWORD_PARAMETERS };
}

export const SEND_VERIFICATION_EMAIL_LINK_REQUEST = 'SEND_VERIFICATION_EMAIL_LINK_REQUEST';
export const SEND_VERIFICATION_EMAIL_LINK_SUCCESS = 'SEND_VERIFICATION_EMAIL_LINK_SUCCESS';
export const SEND_VERIFICATION_EMAIL_LINK_FAILURE = 'SEND_VERIFICATION_EMAIL_LINK_FAILURE';

export function sendVerificationEmailLinkRequest(userProfileId) {
    return { type: SEND_VERIFICATION_EMAIL_LINK_REQUEST, userProfileId };
}

export function sendVerificationEmailLinkSuccess(status) {
    return { type: SEND_VERIFICATION_EMAIL_LINK_SUCCESS, status };
}

export function sendVerificationEmailLinkFailure(errorMessage) {
    return { type: SEND_VERIFICATION_EMAIL_LINK_FAILURE, errorMessage };
}

export const VALIDATION_ERROR_MODAL_RESET = 'VALIDATION_ERROR_MODAL_RESET';

export function resetValidationErrorModal() {
    return { type: VALIDATION_ERROR_MODAL_RESET };
}



// WEBPACK FOOTER //
// ./app/containers/edit-teacher/actions.js